import React from "react";
import Icon from "../icons/Icon";
import Select from "./Select";
import { PAGE_GAP, pageWindow, visibleRange } from "../../lib/pagination";

const DEFAULT_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

const PAGE_SIZE_LABEL = "Itens por página";

function Pagination({
  label = "Paginação",
  page,
  totalPages,
  total,
  pageSize,
  pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
  onPageChange,
  onPageSizeChange,
}) {
  const { from, to } = visibleRange({ page, pageSize, total });

  // Trocar o tamanho invalida a janela de páginas anterior: a página em foco
  // pode simplesmente não existir no novo recorte.
  const changePageSize = (nextSize) => {
    onPageSizeChange(nextSize);
    onPageChange(1);
  };

  return (
    <nav className="pagination" aria-label={label}>
      <div className="pag-count">
        Mostrando {from}–{to} de {total}
      </div>

      <div className="pag-controls">
        {onPageSizeChange && (
          <div className="pag-size">
            {/* O gatilho do Select já carrega o rótulo para quem usa leitor de
                tela; sem o aria-hidden o texto ao lado seria anunciado duas
                vezes seguidas. */}
            <span className="pag-size-label" aria-hidden="true">
              {PAGE_SIZE_LABEL}
            </span>
            <Select
              label={PAGE_SIZE_LABEL}
              value={pageSize}
              options={pageSizeOptions.map((option) => ({
                value: option,
                label: String(option),
              }))}
              onChange={changePageSize}
            />
          </div>
        )}

        <div className="pag-pages">
          <button
            className="pag-btn"
            type="button"
            aria-label="Página anterior"
            disabled={page <= 1}
            onClick={() => onPageChange(page - 1)}
          >
            <Icon name="chevron-left" strokeWidth={2.5} />
          </button>

          {pageWindow(page, totalPages).map((entry, index) =>
            entry === PAGE_GAP ? (
              <span className="pag-gap" key={`${PAGE_GAP}-${index}`} aria-hidden="true">
                …
              </span>
            ) : (
              <button
                className={entry === page ? "pag-btn is-current" : "pag-btn"}
                type="button"
                key={entry}
                aria-label={`Página ${entry}`}
                aria-current={entry === page ? "page" : undefined}
                onClick={() => onPageChange(entry)}
              >
                {entry}
              </button>
            )
          )}

          <button
            className="pag-btn"
            type="button"
            aria-label="Próxima página"
            disabled={page >= totalPages}
            onClick={() => onPageChange(page + 1)}
          >
            <Icon name="chevron-right" strokeWidth={2.5} />
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Pagination;
